import { defineMessages } from 'react-intl';

export default defineMessages({
    sendInviteHeader: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Send Invite Header',
        defaultMessage: 'Send Invite'
    },
    sendInviteButton: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Send Invite Button',
        defaultMessage: 'Send Invite'
    },
    cancel: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Cancel',
        defaultMessage: 'Cancel'
    },
    noEmailHeader: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Insured Name Header',
        defaultMessage: '{name} does not have an email on file. Please provide one to send the invite.'
    },
    accountEmailAddress: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Email Address',
        defaultMessage: 'Email Address'
    },
    confirmEmailAddress: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDENewEmailModal.WMICMDENewEmailModal.Confirm Email Address',
        defaultMessage: 'Confirm Email Address'
    }
});
